import { usePaperCounterStore } from '@renderer/stores/paperCounterStore'
import { useSettingsStore } from '@renderer/stores/settingsStore'

const API_BASE_URL =
  (typeof process !== 'undefined' ? process.env?.VITE_API_URL : undefined) ||
  import.meta.env.VITE_API_URL ||
  'https://dreamboothstudio.com'

interface PrintEventPayload {
  eventType: 'session' | 'user_reprint' | 'operator_reprint' | 'test_print'
  copies: number
  printerName?: string
  printerType?: 'default' | 'secondary' | 'tertiary'
  printerTarget?: 'default' | 'remote'
  remotePrinterMachineId?: string
  success: boolean
  error?: string
  projectId?: string
  sessionId?: string
}

export async function logPrintEvent(payload: PrintEventPayload): Promise<void> {
  if (!Number.isFinite(payload.copies) || payload.copies <= 0) return

  const deviceId = useSettingsStore.getState().deviceId

  if (payload.success) {
    usePaperCounterStore.getState().incrementPrinted(payload.copies)
  }

  if (!deviceId) {
    console.warn('[TELEMETRY] Missing deviceId for print event log')
    return
  }

  try {
    const response = await fetch(`${API_BASE_URL}/api/print-event-log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        deviceId,
        eventType: payload.eventType,
        copies: payload.copies,
        printerName: payload.printerName,
        printerType: payload.printerType,
        printerTarget: payload.printerTarget,
        remotePrinterMachineId: payload.remotePrinterMachineId,
        success: payload.success,
        error: payload.error,
        projectId: payload.projectId,
        sessionId: payload.sessionId,
      })
    })
    if (!response.ok) {
      const errorText = await response.text()
      console.warn('[PrintEventLogger] Print event log failed:', response.status, errorText)
    }
  } catch (err) {
    console.error('[PrintEventLogger] Failed to log print event:', err)
  }
}
